"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchActivities = exports.genQueryParams = exports.fetchActivityTypes = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const ActionTypes = require("../../actionTypes/activity/list");
const Actions = require("../../actions/activity/list");
const sok_types_1 = require("@caddigital/sok-types");
function fetchActivityTypes(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_ACTIVITY_TYPES_REQUEST), (0, operators_1.mergeMap)((action) => {
        const briefcaseUuid = action.payload && action.payload.briefcaseUuid;
        const url = briefcaseUuid
            ? `${baseUrl}api/briefcase/${briefcaseUuid}/activity-types`
            : `${baseUrl}api/admin/activity/types`;
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url
        }).pipe((0, operators_1.mergeMap)(({ response }) => {
            const val = t.array(t.interface({
                id: t.number,
                name: t.string
            }));
            const validation = val.decode(response);
            const act = validation.fold((e) => Actions.fetchActivityTypesFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchActivityTypesSuccess(e));
            return (0, rxjs_1.of)(act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchActivityTypesFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.fetchActivityTypes = fetchActivityTypes;
function genQueryParams(searchOpts) {
    return Object.keys(searchOpts).reduce((prev, key) => {
        if (!searchOpts[key] || key === 'briefcaseUuid') {
            return prev;
        }
        let str = '';
        if (prev === '') {
            str += '?';
        }
        else {
            str += '&';
        }
        str += `${encodeURIComponent(key)}=${encodeURIComponent(searchOpts[key])}`;
        prev += str;
        return prev;
    }, '');
}
exports.genQueryParams = genQueryParams;
function fetchActivities(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_ACTIVITIES_REQUEST), (0, operators_1.mergeMap)((action) => {
        const searchOpts = action.payload.options || {};
        const query = genQueryParams(searchOpts);
        const url = searchOpts.briefcaseUuid
            ? `${baseUrl}api/briefcase/${searchOpts.briefcaseUuid}/activity${query}`
            : `${baseUrl}api/admin/activity${query}`;
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url
        }).pipe((0, operators_1.mergeMap)(({ response }) => {
            const val = t.array(sok_types_1.Activity.iActivity);
            const validation = val.decode(response);
            const act = validation.fold((e) => Actions.fetchActivitiesFailure((0, errorHandling_1.parseValidationError)(e)), (e) => Actions.fetchActivitiesSuccess(e));
            return (0, rxjs_1.of)(act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchActivitiesFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.fetchActivities = fetchActivities;
//# sourceMappingURL=list.js.map